import {_utils, viewportChecker} from "../../../utils/_utils.js";
import {_state} from "../../../state/state.js";
import {_libs} from "../../../utils/_libs.js";
import gsap from "gsap";

export const heroDriverBlock = () => {
    return new Promise((resolve, reject) => {
        _utils.initSection('.hero-driver', (section, sectionIndex) => init(section, sectionIndex));
        resolve();
    })
}

const init = (section, sectionIndex) => {
    const slider = section.querySelector('.hero-driver__cards');
    const pagination = slider.querySelector('.swiper-pagination');

    let swiper = null;

    const createSwiper = () => {
        if (swiper !== null) {
            swiper.destroy(true, true);
            swiper = null;
        }

        if (!swiper && !_state.isDesktop) {
            swiper = _libs._swiper(slider, {
                slidesPerView: 1,
                speed: 800,
                spaceBetween: 16,
                keyboard: {
                    enabled: true,
                },
                pagination: {
                    el: pagination,
                },
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                    },
                },
            });
        }
    }

    createSwiper();
    const rebuildFunc = () => {
        createSwiper();
    }
    _utils.rebuildComponentsOnResize(rebuildFunc);
}